import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JsBridgeService {
  private valuesReadyResolve!: (value: any) => void;
  valuesReady = new Promise((resolve) => {
    this.valuesReadyResolve = resolve;
  });
  private resolved = false;

  constructor() {
    (window as any).receiveValuesFromNative = (data: string) => {
      console.log('[JSBridge] receiveValuesFromNative raw:', data);

      try {
        const keyValueObject = JSON.parse(data ?? 'null');
        console.log('[JSBridge] parsed object:', keyValueObject);

        if (keyValueObject && typeof keyValueObject === 'object' && keyValueObject !== null) {
          for (const [key, value] of Object.entries(keyValueObject)) {
            try {
              localStorage.setItem(key, String(value));
            } catch (e) {
              console.warn('[JSBridge] localStorage set failed', { key, e });
            }
          }
        }

        this.safeResolve(keyValueObject);
      } catch (e) {
        console.error('[JSBridge] receiveValuesFromNative failed, resolving anyway', e);
        this.safeResolve(undefined);
      }
    };
  }

  /*
  MARK: FUNZIONI DI SCRITTURA SU PONTE JS
   */
  openPdf(url: string) {
    var isWebApp = false;
    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        (window as any).webkit.messageHandlers.openPDF.postMessage(url)
        return;
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }

    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        (window as any).JSInterface.openPDF(url)
        return;
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }

    window.open(url, '_blank')
  }

  openExternalUrl(url: string): void {
    if (!url) {
      console.warn('[JSBridge] openExternalUrl: invalid url', url);
      return;
    }

    const trimmedUrl = url.trim();
    console.log('[JSBridge] openExternalUrl called:', trimmedUrl);

    // iOS
    try {
      if ((window as any)?.webkit?.messageHandlers?.openExternalUrl) {
        (window as any).webkit.messageHandlers.openExternalUrl.postMessage(trimmedUrl);
        return;
      }
    } catch (err) {
      console.log('[JSBridge] iOS native context does not exist yet');
    }

    // Android
    try {
      if ((window as any)?.JSInterface?.openExternalUrl) {
        (window as any).JSInterface.openExternalUrl(trimmedUrl);
        return;
      }
    } catch (err) {
      console.log('[JSBridge] Android native context does not exist yet');
    }

    // Fallback Web
    console.log('[JSBridge] Web fallback: window.open');
    window.open(trimmedUrl, '_blank', 'noopener');
  }

  login(userLogin: UserLogin) {
    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        (window as any).webkit.messageHandlers.login.postMessage(userLogin)
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }

    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        (window as any).JSInterface.login(JSON.stringify(userLogin))
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }
  }

  logout(userLogout: UserLogin) {
    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        (window as any).webkit.messageHandlers.logout.postMessage(userLogout)
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }

    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        (window as any).JSInterface.logout(JSON.stringify(userLogout))
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }
  }

  appInitEnd() {
    console.log('[JSBridge] appInitEnd called');
    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        console.log('[JSBridge] calling ios appInitEnd');

        (window as any).webkit.messageHandlers.appInitEnd.postMessage(true)
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }

    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        console.log('[JSBridge] calling Android appInitEnd');

        (window as any).JSInterface.appInitEnd(true)
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }
  }

  startScanner() {
    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        (window as any).webkit.messageHandlers.startScanner.postMessage(true)
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }

    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        (window as any).JSInterface.startScanner(true)
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }
  }


  clearPushNotification() {
    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        (window as any).webkit.messageHandlers.clearPushNotification.postMessage(true)
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }

    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        (window as any).JSInterface.clearPushNotification(true)
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }
  }

  openFile(blob: any, mimeType: string, fileName: string) {
    console.log('[JSBridge] openFile called', {
      hasJSInterface: !!(window as any).JSInterface,
      mimeType,
      fileName,
      payloadType: typeof blob,
      payloadLength: typeof blob === 'string' ? blob.length : undefined
    });

    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        (window as any).webkit.messageHandlers.downloadFile.postMessage({
          blob: blob, mimeType: mimeType, fileName: fileName
        });
        return;
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }
    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        (window as any).JSInterface.downloadFile(blob, mimeType, fileName)
        return;
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }

  }

  setModePortrait() {
    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        (window as any).webkit.messageHandlers.setPortrait.postMessage(true);
        return;
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }
    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        (window as any).JSInterface.setPortrait()
        return;
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }

  }

  setModeLandscape() {
    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        (window as any).webkit.messageHandlers.setLandscape.postMessage(true);
        return;
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }
    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        (window as any).JSInterface.setLandscape()
        return;
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }

  }

  uploadFile() {
    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        (window as any).webkit.messageHandlers.uploadFile.postMessage(true);
        return;
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }
    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        (window as any).JSInterface.uploadFile()
        return;
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }

  }

  isNativeContext(): boolean {
    const w = window as any;
    // Check handler specifici dell'app nativa (non il generico webkit.messageHandlers
    // che potrebbe essere esposto da browser iOS basati su WKWebView come Chrome)
    const hasIOSBridge = !!w?.webkit?.messageHandlers?.login;
    const hasAndroidBridge = !!w?.JSInterface;
    const result = hasIOSBridge || hasAndroidBridge;
    console.log('[JSBridge] isNativeContext:', result);
    return result;
  }


  saveSharedPreferences(key: string, value: string) {
    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        (window as any).webkit.messageHandlers.saveInSharedPreferences.postMessage({
          key: key, value: value
        });
        return;
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }
    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        (window as any).JSInterface.saveInSharedPreferences(key, value)
        return;
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }

  }

  getSharedValues(keys: string[]) {
    const w = window as any;

    try {
      if (w?.webkit?.messageHandlers?.getValues) {
        w.webkit.messageHandlers.getValues.postMessage(JSON.stringify(keys));
        return;
      }
    } catch {
    }

    try {
      if (w?.JSInterface?.getValues) {
        w.JSInterface.getValues(JSON.stringify(keys));
        return;
      }
    } catch {
    }

    console.log('[JSBridge] Web context -> resolve immediately');
    this.safeResolve(undefined);
  }

  private safeResolve(value: any) {
    if (this.resolved) return;
    this.resolved = true;
    this.valuesReadyResolve(value);
  }

  removeSharedValues(keys: string[]) {
    try {
      if ((window as any).webkit !== undefined && (window as any).webkit.messageHandlers !== undefined) {
        (window as any).webkit.messageHandlers.removeValues.postMessage(JSON.stringify(keys));
        return;
      }
    } catch (err) {
      console.log('iOS native context does not exist yet')
    }
    try {
      if ((window as any).JSInterface !== undefined && (window as any).JSInterface !== null) {
        (window as any).JSInterface.removeValues(JSON.stringify(keys))
        return;
      }
    } catch (err) {
      console.log('Android context does not exist yet')
    }

  }
}

export interface UserLogin {
  userId: string;
  accessToken: string;
}
